import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import MemberFollowup from "@/pages/MemberFollowup";

export const Route = createFileRoute("/member-followup/$token")({
  head: ({ params }) => seoHead(`/member-followup/${params.token}`),
  component: MemberFollowup,
});
